<template>
  <div class="informdisclosure">
    <header-view :tabsign="6"></header-view>
    <div class="pic">信息公开</div>
    <div class="body w12 min-h">
      <div class="toptitle">
        <div class="left_c">
          <div class="redcon"></div>
          <span>信息公开</span>
        </div>
        <div class="right_c">
          <div class="searchcon">
            <input class="inputa" v-model="searchv" @input="changeinput" />
          </div>
        </div>
      </div>

      <div class="centent">

        <div class="lista">
          <div
            v-for="(item, index) in typelist"
            class="listsignle"
            @click="changetab(index)"
            :key="index"
          >
            <div :class="index == indexsign ? 'signlea_cur' : 'signlea'">
              <div>{{ item.title||'' }}</div>
            </div>
            <div v-if="index<typelist.length-1" :class="index == indexsign ? '' : 'linecon'"></div>
          </div>
        </div>
        <div class="listb">
          <div v-for="(item, index) in list" :key="index">
            <!-- <router-link :to="'/noticeDetails?index=' + index + '&id=' + item.id"> -->
            <div @click="toDatail(index, item)" class="signleb">
              <div class="titlecon overf-elli" :title="item.title">
                {{ item.title || "" }}
              </div>
              <div class="timecon">
                {{ item.createTime || "" }}
              </div>
            </div>
            <!-- </router-link> -->
          </div>
        </div>
      </div>


    </div>
    <zhini-pagination
      class="zhini-pagination"
      :currentPage="pageNo"
      :totalPage="totalPage"
      @pageNum="pageNum"
    ></zhini-pagination>
  </div>
</template>

<script>
import zhiniPagination from "../../components/zhini-pagination.vue";
export default {
  name: "informatedisclosure",
  components: {
    zhiniPagination,
  },
  data: function () {
    return {
      list: "",
      pageNo: 1,
      pageSize: 15,
      totalPage: 0,
      url: "",
      typesign: 0,
      indexsign: 0,
	    typelist:[],
      searchv: "",
    };
  },
  created() {
    this.getSys()
    window.pageYOffset = 0;
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;
  },
  computed:{
    infotype:function(){
      var str=this.typelist.length?this.typelist[this.indexsign].value:''
      return str
    }
  },
  watch: {
    $route() {
      this.typesign = this.$route.query.type;
    },
    typesign() {
      this.typesign = this.$route.query.type;
      this.getSys()
    },
  },
  methods: {
    getSys(){//
      this.httpGet("web/dict/getDictItems/info_types").then(res => {
        if(res.success){
          this.typelist = res.result;
          this.init();
        }
      });
    },
    //搜索
    changeinput() {
      this.pageNo=1
      this.init();
    },

    //变化类型
    changetab(index) {
      this.pageNo=1
      this.indexsign = index;
      this.init();
    },

    toDatail(indexsign, item) {

      if(item.content.indexOf('.pdf')!=-1||item.content.indexOf('.PDF')!=-1){
        var list=item.content?item.content.split(','):[];

        var i=0;
        var timer=setInterval(()=>{
          if(i<list.length){

            console.log('url',list[i])
            if(list[i]){
              window.open(this.$baseURL+list[i])
            }
            i++;
          }else{
            timer=null;
            clearInterval(timer)
          }
        },1000)
      }else{
        this.$router.push({
          path: "/informatedisclosuredetail",
          query: { index: indexsign, id: item.id },
        });
      }

    },

    init() {
      var that = this;
      this.httpGet("web/info/list", {
			infoType: this.infotype,
			pageNo: this.pageNo,
			pageSize: this.pageSize,
			title: this.searchv,
      }).then((res) => {
			that.list = res.result.records;
			that.totalPage = Math.ceil(res.result.total / that.pageSize);
      });
    },
    pageNum(e) {
      window.pageYOffset = 0;
      document.documentElement.scrollTop = 0;
      document.body.scrollTop = 0;

      this.pageNo = e;
      this.init();
    },
  },
};
</script>
<style scoped="scoped" lang="scss">
::-webkit-scrollbar {
  width: 0px;
}
.informdisclosure {
  width: 100%;
  position: relative;
  .pic {
    width: 100%;
    height: 400px;
    font-size: 75px;
    font-weight: 500;
    color: #e61f26;
    text-align: center;
    line-height: 400px;
    margin-top: 100px;
    background: url(../../assets/newimg/publicannounce_img.png) no-repeat top
      center/ 100% 100%;
  }
  .body {
    background: #ffffff;
    margin: 20px auto 0;
    .centent {
      margin: 20px auto;
      .lista {
        width: 100%;
        height:37px;
        background: #fbfbfb;
        display: flex;
        align-items: center;
        .listsignle {
          display: flex;
          align-items: center;
        }
        .signlea,.signlea_cur{
          width: 107px;
          height:37px;
          line-height:37px;
          text-align: center;
          font-size: 16px;
		      cursor: pointer;
        }
        .signlea {
          color: #666666;
        }
        .signlea_cur {
          background: #e70012;
          color: #ffffff;
        }
        .linecon {
          width: 1px;
          height:17px;
          background: #666666;
          opacity: 0.3;
        }
      }

      .listb {
        margin-top:40px;
        .signleb {
          padding-left: 20px;
          cursor: pointer;
          height:70px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          font-size: 16px;
          font-weight: bold;
          color: #333333;
          border-bottom: 1px dashed #e6e6e6;
          .titlecon {
            font-size:18px;
            font-weight: 400;
            color: #333333;
            width: calc(100% - 170px);
          }
          .titlecon:hover {
            color: rgba(230, 31, 38, 1);
          }
          .timecon {
            font-size:18px;
            font-weight: 400;
            color: #999999;
          }
        }
      }
    }
    .zhini-pagination {
      position: absolute;
      bottom: 10px;
      width: 100%;
      left: 0px;
    }

    .toptitle {
      height: 60px;
      border-bottom: 1px solid #ededed;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_c {
        display: flex;
        align-items: center;
        .redcon {
          width: 5px;
          height: 20px;
          background: #e70012;
          margin-right: 20px;
        }
        font-size:25px;
        font-weight: 400;
        color: #e61f26;
      }
      .right_c {

        .searchcon {
          height: 40px;
          line-height: 40px;
          border-radius: 15px;
          padding-left: 20px;
          padding-right:20px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          .inputa {
            width: 268px;
            height:37px;
            font-size:14px;
            padding: 0px 45px 0px 14px;
            border: 1px solid #f1f1f1;
            border-radius:15px;
            background: url(../../assets/searchimg.png) no-repeat;
            background-position: 230px 8px;
          }
          .imgcon {
            height:18px;
            width:18px;
          }
        }
      }
    }
  }
}
</style>
